export function GMap() {
	return new Promise(function (resolve, reject) {
		window.initMap = function () {
			resolve(google);
		}
		window.google = {};
		var Gmap_apikey = window.localStorage.getItem('Gmap_apikey') || 'AIzaSyCLZygIc0eehfTy3nZ8blsDtt0vFcRRx38';
		var script = document.createElement("script");
		script.type = "text/javascript";
		script.src = "https://maps.googleapis.com/maps/api/js?key="+Gmap_apikey+"&callback=initMap";
		script.async = true;
		script.defer = true;
		script.onerror = reject;
		document.head.appendChild(script);
	})
}


// WEBPACK FOOTER //
// ./src/config/GMap.js